import { useParams } from 'react-router-dom';
import { Box, Skeleton, Text } from '@hopskipdrive/react-components';
import HandshakeIcon from '@mui/icons-material/Handshake';

import { LabelChip } from '../../../../../shared/components/LabelChip';
import { colorPalette, colorTokens } from '../../../../../shared/components/variables';

import { useRiderRequiredServicesQuery } from './useRiderRequiredServicesQuery';

interface RiderRequiredServicesProps {
  riderSlug: string;
  isCarePartnerRide?: boolean;
}

export const RiderRequiredServices = ({ riderSlug, isCarePartnerRide }: RiderRequiredServicesProps) => {
  const { rideSlug } = useParams();
  const { data: requiredServicesResponse, isFetching } = useRiderRequiredServicesQuery({
    rideSlug: rideSlug || '',
    riderSlug: riderSlug,
  });

  if (isFetching) {
    return <RiderRequiredServicesSkeleton />;
  }

  return (
    <>
      {isCarePartnerRide && !!requiredServicesResponse?.data?.carePartnerRequiredServices?.length && (
        <Box display="flex" flexDirection="column" gap="6px" flexWrap="wrap" width="100%">
          <Text variant="subtitle1" style={{ color: colorTokens.text.secondary }}>
            CarePartner Services Required
          </Text>
          <Box display="flex" gap="6px" flexWrap="wrap">
            {requiredServicesResponse.data.carePartnerRequiredServices.map((service) => (
              <LabelChip
                key={service}
                label={service}
                isFetching={false}
                bgColor={colorPalette.plum950}
                textColor={colorTokens.plum.dark}
                border={`1px solid ${colorTokens.plum.outlineBorder}`}
                icon={<HandshakeIcon style={{ color: colorTokens.plum.dark }} />}
              />
            ))}
          </Box>
        </Box>
      )}
      {!!requiredServicesResponse?.data?.nonCarePartnerRequiredServices?.length && (
        <Box display="flex" flexDirection="column" gap="6px" flexWrap="wrap" width="100%">
          <Text variant="subtitle1" style={{ color: colorTokens.text.secondary }}>
            Services Required
          </Text>
          <Box display="flex" gap="6px" flexWrap="wrap">
            {requiredServicesResponse.data.nonCarePartnerRequiredServices.map((service) => (
              <LabelChip
                key={service}
                label={service}
                isFetching={false}
                bgColor={colorPalette.navy975}
                textColor={colorTokens.primary.main}
                border={`1px solid ${colorTokens.primary.outlineBorder}`}
              />
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};

export const RiderRequiredServicesSkeleton = () => {
  return (
    <Box display="flex" gap="8px" flexWrap="wrap">
      <Skeleton width={76} height={35} />
      <Skeleton width={64} height={35} />
      <Skeleton width={76} height={35} />
    </Box>
  );
};
